/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, June 2023
 * @format
 * @flow
 */

import React from 'react';
import cn from 'classnames';
import { Box, Typography } from '@material-ui/core';
import useStyles from './useStyles';
import { TmsComponents } from '../../../../../enums';

const SubTools = ({ selectedSubTool, subTools, onClickSubTool, toolType, getSeatCapacityCount }) => {
  const classes = useStyles();

  const renderToolName = (childTool) => {
    if (toolType === TmsComponents.table) {
      const { assignedCount, unAssignedCount } = getSeatCapacityCount(childTool);
      const total = assignedCount + unAssignedCount;
      const seatName = total === 0 ? `(0)` : `(${assignedCount}/${total})`;
      return (
        <React.Fragment>
          <Typography
            variant='body2'
            className={cn(
              { [classes.selectedTxt]: selectedSubTool?.type === childTool?.type }
            )}>
            {childTool?.name}
          </Typography>
          <Typography
            variant='body2'
            className={cn(
              { [classes.selectedTxt]: selectedSubTool?.type === childTool?.type }
            )}>
            {seatName}
          </Typography>
        </React.Fragment>
      );
    } else {
      return (
        <Typography
          variant='body2'
          className={cn(
            { [classes.selectedTxt]: selectedSubTool?.type === childTool?.type }
          )}>
          {childTool?.name}
        </Typography>
      );
    }
  };

  return (
    <Box className={cn(classes.scrollXContainer)}>
      {subTools.map(tool =>
        <Box
          minWidth={'80px'}
          minHeight={'50px'}
          px={2}
          key={tool.type}
          onClick={() => onClickSubTool(tool)}
          className={cn(
            classes.gridBox,
            classes.seatBox,
            { [classes.selectedTool]: selectedSubTool?.type === tool?.type }
          )}>
          {renderToolName(tool)}
        </Box>
      )}
    </Box>
  );
};

export default SubTools;
